import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';
import { DemoModeService } from '../demo/demo-mode.service';

@Injectable({
  providedIn: 'root',
})
export class CanSeeOnlyWhenLoggedInGuard {
  private readonly _auth = inject(AuthService);
  private readonly _router = inject(Router);
  private readonly _demo = inject(DemoModeService);

  canActivate(): Observable<boolean | UrlTree> {
    // Wait for the SDK to finish restoring the session (from localStorage or a
    // redirect callback) BEFORE deciding — a real session must always win over
    // a stale demo flag, so the demo interceptor can never shadow real data.
    return this._auth.isLoading$.pipe(
      filter((loading) => !loading),
      take(1),
      switchMap(() => this._auth.isAuthenticated$),
      take(1),
      map((isAuthenticated) => {
        if (isAuthenticated) {
          this._demo.disable();
          return true;
        }
        // Signed-out: demo visitors tour the app on simulated data; everyone
        // else lands on the marketing page at the root (not the login form).
        return this._demo.active ? true : this._router.parseUrl('/');
      }),
    );
  }
}
